export const FilterOverlay: React.FC<{ onClick?: () => void }> = ({ children, onClick }) => {
  return (
    <div onClick={onClick} className="fixed w-full h-full top-0 left-0 z-[5] animate-overlay">
      {children}
    </div>
  );
};
